module.exports = __webpack_public_path__ + "static/media/header-sape.4066599e.png";